<!--
PlanCardDescription for use in PlanCard.vue with customizable price line and details.
-->
<template>
  <div class="details px-lg py-md d-flex flex-column align-items-center justify-content-center">
    <h4 class="m-0 text-nowrap">
      <template v-if="$slots.displayName">
        <slot name="displayName"/>
      </template>
      <template v-else>
        {{ plan?.displayName }}
      </template>
    </h4>
    <div class="separator my-sm"/>
    <p class="semi-bold color-plum">
      {{ computedPriceLine }}
    </p>
    <slot
      v-if="$slots.details"
      name="details"/>
    <template v-else>
      <p>
        {{ `Rent ${plan?.nItems} item${plan?.nItems > 1 ? 's' : ''} at a time.` }}
      </p>
      <p v-if="plan?.shipmentsPerInterval">
        Swap every 30 days.
      </p>
      <p v-else>
        <b>Unlimited</b> Swaps.
      </p>
      <p v-if="showCancelAnytime">
        Cancel anytime.
      </p>
    </template>
    <slot
      v-if="$slots.footer"
      name="footer"/>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatPrice } from '@/utils/stringParsing.js'
import { usePlans } from '@shared/composables/plans.js'

const props = defineProps({
  planId: {
    type: String,
    required: true
  },
  priceLine: {
    type: String,
    default: null
  },
  showCancelAnytime: {
    type: Boolean,
    default: true
  }
})

const { planById } = usePlans()

const plan = computed(() => planById(props.planId))
const basePrice = computed(() => plan.value?.basePrice ? plan.value.basePrice / 100.0 : 0)
const computedPriceLine = computed(() => props.priceLine ? props.priceLine : `${basePriceFormatted.value}/month.`)
const basePriceFormatted = computed(() => formatPrice(basePrice.value, true, true))
</script>

<style scoped lang="scss">
.details {
  background-color: $white;
  border: 1px solid $pewter;
  border-radius: 2px;
  min-height: 178px;

  .separator {
    width: 32px;
    height: 1px;
    background-color: $ash;
  }
}
</style>
